export default "__VITE_ASSET__D6r8UG7P__"